import { GetStaticProps, GetStaticPaths } from 'next';
import { templates, templateCategories } from '@/config/templates';
import CategoryPage from '../../[category]';

const TEMPLATES_PER_PAGE = 12;

export default CategoryPage;

export const getStaticPaths: GetStaticPaths = async () => {
  const paths: { params: { category: string; page: string } }[] = [];
  
  templateCategories.forEach(category => {
    const categorySlug = category === 'All' ? 'all' : category.toLowerCase().replace(/[^a-z0-9]/g, '-');
    const categoryTemplates = category === 'All' 
      ? templates 
      : templates.filter(t => t.category === category);
    const totalPages = Math.ceil(categoryTemplates.length / TEMPLATES_PER_PAGE);
    
    // Generate paths for pages 2 and onwards (page 1 is handled by [category].tsx)
    for (let page = 2; page <= totalPages; page++) {
      paths.push({
        params: { 
          category: categorySlug,
          page: page.toString()
        }
      });
    }
  });

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const categorySlug = params?.category as string;
  const page = parseInt(params?.page as string) || 1;
  
  const category = categorySlug === 'all' ? 'All' : 
    templateCategories.find(cat => cat.toLowerCase().replace(/[^a-z0-9]/g, '-') === categorySlug) || 'All';

  return {
    props: {
      category,
      currentPage: page,
    },
  };
};